import type { Tab } from 'modules/core/components/Card/types'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import type { Navigation } from 'modules/core/lib/navigation/context'
import type { NavigationPaths } from 'modules/core/lib/navigation/context'

import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

export type TabTypes =
  | 'edit'
  | 'preferences'
  | 'work_time_categories'
  | 'compensation'
  | 'employees'
  | 'breaks'

export function isOfTypeTabs(keyInput: string): keyInput is TabTypes {
  return [
    'edit',
    'preferences',
    'work_time_categories',
    'compensation',
    'employees',
    'breaks',
  ].includes(keyInput)
}

const getTabId = (
  navigation: Navigation<NavigationPaths>,
  settingId: number,
  tabId: TabTypes
): string => {
  return navigation.settings.time_tracking.settingId.tabId.fullPath({
    settingId,
    tabId,
  })
}

export const buildTabs = (
  attendanceSetting: AttendanceSetting,
  navigation: Navigation<NavigationPaths>
): Tab[] => {
  const settingId = attendanceSetting.attributes.id
  const hasMajorationEnabled = hasFeature('dev_time_tracking_majoration')
  const hasBankOfHours = hasFeature('dev_time_tracking_bank_of_hours')

  const tabs: Tab[] = [
    {
      name: i18n.t('time_tracking.settings.tabs.policy_settings'),
      index: true,
      href: getTabId(navigation, settingId, 'edit'),
    },
    {
      name: i18n.t('time_tracking.settings.tabs.preferences'),
      index: false,
      href: getTabId(navigation, settingId, 'preferences'),
    },
    ...(hasMajorationEnabled || hasBankOfHours
      ? [
          {
            name: i18n.t('time_tracking.settings.tabs.work_time_categories'),
            index: false,
            href: getTabId(navigation, settingId, 'work_time_categories'),
          },
        ]
      : []),
    {
      name: i18n.t('time_tracking.settings.tabs.compensation'),
      index: false,
      href: getTabId(navigation, settingId, 'compensation'),
    },
    {
      name: i18n.t('time_tracking.settings.tabs.breaks'),
      index: false,
      href: getTabId(navigation, settingId, 'breaks'),
    },
    {
      name: i18n.t('time_tracking.settings.tabs.employees'),
      index: false,
      href: getTabId(navigation, settingId, 'employees'),
    },
  ]

  return tabs
}
